// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#no-electives-msg {
  font-weight: 500;
  font-family: Verdana, Arial, sans-serif;
  color: #00375d;
  font-size: 16px;
  font-style: italic;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentElectives.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["#no-electives-msg {\n  font-weight: 500;\n  font-family: Verdana, Arial, sans-serif;\n  color: #00375d;\n  font-size: 16px;\n  font-style: italic;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
